import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55536254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "page-wrapper" }
const _hoisted_4 = { class: "page-header" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "page-title" }, "Informations générales", -1))
const _hoisted_8 = {
  key: 0,
  class: "page-subtitle"
}
const _hoisted_9 = {
  key: 0,
  class: "matricule-badge"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow" }, null, -1))
const _hoisted_11 = { class: "info-grid" }
const _hoisted_12 = {
  key: 0,
  class: "info-block"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-icon identity" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "block-title" }, "Identité")
], -1))
const _hoisted_14 = { class: "block-body" }
const _hoisted_15 = {
  key: 0,
  class: "field-row"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Matricule", -1))
const _hoisted_17 = { class: "field-value mono" }
const _hoisted_18 = {
  key: 1,
  class: "field-row"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Nom", -1))
const _hoisted_20 = { class: "field-value" }
const _hoisted_21 = {
  key: 2,
  class: "field-row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Prénom", -1))
const _hoisted_23 = { class: "field-value" }
const _hoisted_24 = {
  key: 3,
  class: "field-row"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Sexe", -1))
const _hoisted_26 = { class: "field-value" }
const _hoisted_27 = { class: "tag tag-blue" }
const _hoisted_28 = {
  key: 4,
  class: "field-row"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Date de naissance", -1))
const _hoisted_30 = { class: "field-value" }
const _hoisted_31 = {
  key: 1,
  class: "info-block"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-icon contact" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-email" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "block-title" }, "Contact")
], -1))
const _hoisted_33 = { class: "block-body" }
const _hoisted_34 = {
  key: 0,
  class: "field-row"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Email", -1))
const _hoisted_36 = { class: "field-value" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 1,
  class: "field-row"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Téléphone", -1))
const _hoisted_40 = { class: "field-value" }
const _hoisted_41 = {
  key: 2,
  class: "field-row"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Adresse", -1))
const _hoisted_43 = { class: "field-value" }
const _hoisted_44 = {
  key: 3,
  class: "field-row"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Commune", -1))
const _hoisted_46 = { class: "field-value" }
const _hoisted_47 = {
  key: 4,
  class: "field-row"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Quartier", -1))
const _hoisted_49 = { class: "field-value" }
const _hoisted_50 = {
  key: 2,
  class: "info-block"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-icon category" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layers" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "block-title" }, "Catégories")
], -1))
const _hoisted_52 = { class: "block-body" }
const _hoisted_53 = {
  key: 0,
  class: "field-row"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Catégorie étudiant", -1))
const _hoisted_55 = { class: "field-value" }
const _hoisted_56 = { class: "tag tag-info" }
const _hoisted_57 = {
  key: 1,
  class: "field-row"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Formateur", -1))
const _hoisted_59 = { class: "field-value" }
const _hoisted_60 = { class: "tag tag-success" }
const _hoisted_61 = {
  key: 3,
  class: "info-block"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-icon pro" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-briefcase" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "block-title" }, "Informations professionnelles")
], -1))
const _hoisted_63 = { class: "block-body" }
const _hoisted_64 = {
  key: 0,
  class: "field-row"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Qualification", -1))
const _hoisted_66 = { class: "field-value" }
const _hoisted_67 = {
  key: 1,
  class: "field-row"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Expérience", -1))
const _hoisted_69 = { class: "field-value" }
const _hoisted_70 = { class: "tag tag-orange" }
const _hoisted_71 = {
  key: 2,
  class: "field-row"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Poste occupé", -1))
const _hoisted_73 = { class: "field-value" }
const _hoisted_74 = {
  key: 3,
  class: "field-row"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Catégorie prof.", -1))
const _hoisted_76 = { class: "field-value" }
const _hoisted_77 = {
  key: 4,
  class: "field-row"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, "Infos complémentaires", -1))
const _hoisted_79 = { class: "field-value text-muted" }
const _hoisted_80 = {
  key: 4,
  class: "info-block"
}
const _hoisted_81 = { class: "block-header" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-icon activities" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layers" })
], -1))
const _hoisted_83 = { class: "block-title" }
const _hoisted_84 = { class: "count-badge" }
const _hoisted_85 = { class: "block-body" }
const _hoisted_86 = { class: "tags-cloud" }
const _hoisted_87 = {
  key: 5,
  class: "info-block"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block-icon langues" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-globe" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "block-title" }, "Langues parlées")
], -1))
const _hoisted_89 = { class: "block-body" }
const _hoisted_90 = { class: "tags-cloud" }
const _hoisted_91 = {
  key: 0,
  class: "info-block full-width"
}
const _hoisted_92 = { class: "block-header" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-icon pieces" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file" })
], -1))
const _hoisted_94 = { class: "block-title" }
const _hoisted_95 = { class: "count-badge" }
const _hoisted_96 = { class: "block-body p-0" }
const _hoisted_97 = { class: "pieces-table" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type de pièce"),
    /*#__PURE__*/_createElementVNode("th", null, "Numéro"),
    /*#__PURE__*/_createElementVNode("th", null, "Aperçu"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_99 = { class: "tag tag-secondary" }
const _hoisted_100 = { class: "mono" }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1))
const _hoisted_103 = [
  _hoisted_102
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal_piece_etudiant = _resolveComponent("modal-piece-etudiant")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _hoisted_7,
              (_ctx.etudiant?.nom)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.etudiant.prenom) + " " + _toDisplayString(_ctx.etudiant.nom) + " ", 1),
                    (_ctx.etudiant?.numeroMatricule)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " #" + _toDisplayString(_ctx.etudiant.numeroMatricule), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_router_link, {
            to: "/liste-etudiants",
            class: "btn-back"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(" Retour à la liste ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.etudiant?.numeroMatricule || _ctx.etudiant?.nom || _ctx.etudiant?.prenom || _ctx.etudiant?.sexe || _ctx.etudiant?.dateNaissance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.etudiant?.numeroMatricule)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.etudiant.numeroMatricule), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.nom)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.etudiant.nom), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.prenom)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.etudiant.prenom), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.sexe)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.etudiant.sexe), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.dateNaissance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.format_Date(_ctx.etudiant.dateNaissance)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.etudiant?.email || _ctx.etudiant?.telephone1 || _ctx.etudiant?.adresse || _ctx.etudiant?.quartier?.commune?.libelle || _ctx.etudiant?.quartier?.libelle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.etudiant?.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("span", _hoisted_36, [
                          _createElementVNode("a", {
                            href: `mailto:${_ctx.etudiant.email}`,
                            class: "link"
                          }, _toDisplayString(_ctx.etudiant.email), 9, _hoisted_37)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.telephone1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.etudiant.telephone1), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.adresse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.etudiant.adresse), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.quartier?.commune?.libelle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.etudiant.quartier.commune.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.quartier?.libelle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.etudiant.quartier.libelle), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.etudiant?.categorieEtudiant || _ctx.etudiant?.categorieFormateur)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  (_ctx.etudiant?.categorieEtudiant)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("span", _hoisted_55, [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.etudiant.categorieEtudiant), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.categorieFormateur)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("span", _hoisted_59, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.etudiant.categorieFormateur), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.etudiant?.qualification?.libelle || _ctx.etudiant?.anneeExperience || _ctx.etudiant?.poste || _ctx.etudiant?.categorie || _ctx.etudiant?.biographie)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  (_ctx.etudiant?.qualification?.libelle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.etudiant.qualification.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.anneeExperience)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("span", _hoisted_69, [
                          _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.etudiant.anneeExperience) + " an(s)", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.poste)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.etudiant.poste), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.categorie)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.etudiant.categorie), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.etudiant?.biographie)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.etudiant.biographie), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.etudiant?.activites?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createElementVNode("h6", _hoisted_83, [
                    _createTextVNode(" Activités "),
                    _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.etudiant.activites.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiant.activites, (activite, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag tag-primary"
                      }, _toDisplayString(activite.libelle), 1))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.etudiant?.langues?.length || _ctx.etudiant?.user?.langues?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.etudiant.user?.langues || _ctx.etudiant.langues || []), (langue, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag tag-warning"
                      }, _toDisplayString(langue.libelle || langue), 1))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.etudiant?.pieces?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("h6", _hoisted_94, [
                  _createTextVNode(" Pièces jointes "),
                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.etudiant.pieces.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("table", _hoisted_97, [
                  _hoisted_98,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiant.pieces, (piece, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_99, _toDisplayString(piece.typePiece?.libelle), 1)
                        ]),
                        _createElementVNode("td", _hoisted_100, _toDisplayString(piece.numeroPiece), 1),
                        _createElementVNode("td", null, [
                          piece
                            ? (_openBlock(), _createBlock(_component_modal_piece_etudiant, {
                                key: 0,
                                fileUrl: piece.urlImage,
                                keyValue: piece.id,
                                libelle: piece.typePiece?.libelle || 'Pièce jointe'
                              }, null, 8, ["fileUrl", "keyValue", "libelle"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.confirmDeletePiece(piece)),
                            class: "btn-delete-piece",
                            title: "Supprimer cette pièce"
                          }, _hoisted_103, 8, _hoisted_101)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}